import ListView from "../../../components/listView/ListView";
import Page from "../../../components/pageView/Page";
import WidgetPage from "../../../components/widgetPage/WidgetPage";

const routesManufacturing = [
  {
    path: "/manufacturing",
    element: WidgetPage,
    props: {
      type: "manufacturing",
      draggable: false,
      resizable: false,
    }
  },
  // Work Capabilities
  {
    path: "/manufacturing/workCapability",
    element: ListView,
    props: { type: "workCapabilityList" }
  },
  {
    path: "/manufacturing/workCapability/new",
    element: Page,
    props: {
      type: "workCapabilityPage",
      options: { mode: "new", load: false }
    }
  },
  {
    path: "/manufacturing/workCapability/:id",
    element: Page,
    props: {
      type: "workCapabilityPage",
      options: { mode: "edit", load: true }
    }
  },
  // Routing Versions
  {
    path: "/manufacturing/routingVersion",
    element: ListView,
    props: { type: "routingVersionList" }
  },
  {
    path: "/manufacturing/routingVersion/new",
    element: Page,
    props: {
      type: "routingVersionPage",
      options: { mode: "new", load: false }
    }
  },
  {
    path: "/manufacturing/routingVersion/:id",
    element: Page,
    props: {
      type: "routingVersionPage",
      options: { mode: "edit", load: true }
    }
  },
  // Work Center Queue
  {
    path: "/manufacturing/queue",
    element: ListView,
    props: { type: "workCenterQueueList" }
  },
  // Work Operations
  {
    path: "/manufacturing/workOperation/:id",
    element: Page,
    props: {
      type: "workOperationPage",
      options: { mode: "edit", load: true }
    }
  },
  // Work Operation Execution (alias for direct access from queue)
  {
    path: "/manufacturing/execution/:id",
    element: Page,
    props: {
      type: "workOperationPage",
      options: { mode: "edit", load: true }
    }
  },
  // Work Order Planner
  {
    path: "/manufacturing/planning",
    element: Page,
    props: {
      type: "workOrderPlannerPage",
      options: { mode: "view", load: false }
    }
  },
  // Work Orders
  {
    path: "/manufacturing/workOrder",
    element: ListView,
    props: { type: "workOrderList" }
  },
  {
    path: "/manufacturing/workOrder/new",
    element: Page,
    props: {
      type: "workOrderPage",
      options: { mode: "new", load: false }
    }
  },
  {
    path: "/manufacturing/workOrder/:id",
    element: Page,
    props: {
      type: "workOrderPage",
      options: { mode: "edit", load: true }
    }
  },
  // Plants
  {
    path: "/manufacturing/plant",
    element: ListView,
    props: { type: "plantList" }
  },
  {
    path: "/manufacturing/plant/new",
    element: Page,
    props: {
      type: "plantPage",
      options: { mode: "new", load: false }
    }
  },
  {
    path: "/manufacturing/plant/:id",
    element: Page,
    props: {
      type: "plantPage",
      options: { mode: "edit", load: true }
    }
  },
  // Work Centers
  {
    path: "/manufacturing/workCenter",
    element: ListView,
    props: { type: "workCenterList" }
  },
  {
    path: "/manufacturing/workCenter/new",
    element: Page,
    props: {
      type: "workCenterPage",
      options: { mode: "new", load: false }
    }
  },
  {
    path: "/manufacturing/workCenter/:id",
    element: Page,
    props: {
      type: "workCenterPage",
      options: { mode: "edit", load: true }
    }
  },
  // Machines
  {
    path: "/manufacturing/machine",
    element: ListView,
    props: { type: "machineList" }
  },
  {
    path: "/manufacturing/machine/new",
    element: Page,
    props: {
      type: "machinePage",
      options: { mode: "new", load: false }
    }
  },
  {
    path: "/manufacturing/machine/:id",
    element: Page,
    props: {
      type: "machinePage",
      options: { mode: "edit", load: true }
    }
  },
  // Machine accessed from WorkCenter context
  {
    path: "/manufacturing/workCenter/:id/machine/:id2",
    element: Page,
    props: {
      type: "machinePage",
      options: { mode: "edit", load: true }
    }
  },
  // Machine Downtime (subcollection)
  {
    path: "/manufacturing/machine/:id/machineDowntime/new",
    element: Page,
    props: {
      type: "machineDowntimePage",
      options: { mode: "new", load: false }
    }
  },
  {
    path: "/manufacturing/machine/:id/machineDowntime/:id2",
    element: Page,
    props: {
      type: "machineDowntimePage",
      options: { mode: "edit", load: true }
    }
  },
  // Quality Checks
  {
    path: "/manufacturing/qualityCheck",
    element: ListView,
    props: { type: "qualityCheckList" }
  },
  {
    path: "/manufacturing/qualityCheck/new",
    element: Page,
    props: {
      type: "qualityCheckPage",
      options: { mode: "new", load: false }
    }
  },
  {
    path: "/manufacturing/qualityCheck/:id",
    element: Page,
    props: {
      type: "qualityCheckPage",
      options: { mode: "edit", load: true }
    }
  },
  // Work Departments
  {
    path: "/manufacturing/workDepartment",
    element: ListView,
    props: { type: "workDepartmentList" }
  },
  {
    path: "/manufacturing/workDepartment/new",
    element: Page,
    props: {
      type: "workDepartmentPage",
      options: { mode: "new", load: false }
    }
  },
  {
    path: "/manufacturing/workDepartment/:id",
    element: Page,
    props: {
      type: "workDepartmentPage",
      options: { mode: "edit", load: true }
    }
  },
  // Settings
  {
    path: "/manufacturing/settings",
    element: Page,
    props: {
      type: "manufacturingSettingsPage",
      options: { mode: "edit", load: true, onMount: 'collapse' }
    }
  },
  // Shifts
  {
    path: "/manufacturing/shift",
    element: ListView,
    props: { type: "shiftList" }
  },
  {
    path: "/manufacturing/shift/new",
    element: Page,
    props: {
      type: "shiftPage",
      options: { mode: "new", load: false }
    }
  },
  {
    path: "/manufacturing/shift/:id",
    element: Page,
    props: {
      type: "shiftPage",
      options: { mode: "edit", load: true, onMount: 'expand' }
    }
  },
];

export default routesManufacturing;
